import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProdAuth } from '../../contexts/ProdAuthContext';

const ACCENT = '#4A7C59';

export const ProductionLogin: React.FC = () => {
  const { login } = useProdAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate('/production', { replace: true });
    } else {
      setError(result.error || 'Invalid credentials');
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell min-h-screen flex items-center justify-center bg-[#FAFAF8]">
      <form onSubmit={handleSubmit} className="w-full max-w-sm p-8">
        <div className="mb-8">
          <div
            className="inline-flex items-center justify-center w-10 h-10 rounded-lg mb-4"
            style={{ backgroundColor: ACCENT }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-[#1A1A1A]">Lot 20 Production</h1>
          <p className="text-sm text-[#6B6B6B] mt-1">Field operations dashboard</p>
        </div>

        {error && (
          <div className={`mb-4 p-3 rounded-lg text-sm border ${
            /invite|not set up/i.test(error)
              ? 'bg-amber-50 border-amber-200 text-amber-700'
              : 'bg-red-50 border-red-200 text-red-700'
          }`}>
            {error}
          </div>
        )}

        <div className="space-y-3 mb-6">
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Email address"
            autoFocus
            required
            className="w-full px-4 py-3 border border-[#E8E6E2] rounded-lg bg-white text-[#1A1A1A] placeholder-[#A3A3A3] focus:outline-none focus:ring-2 focus:border-transparent"
            style={{ '--tw-ring-color': ACCENT } as React.CSSProperties}
            onFocus={e => (e.target.style.boxShadow = `0 0 0 2px ${ACCENT}33`)}
            onBlur={e => (e.target.style.boxShadow = '')}
          />
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Password"
            required
            className="w-full px-4 py-3 border border-[#E8E6E2] rounded-lg bg-white text-[#1A1A1A] placeholder-[#A3A3A3] focus:outline-none focus:ring-2 focus:border-transparent"
            onFocus={e => (e.target.style.boxShadow = `0 0 0 2px ${ACCENT}33`)}
            onBlur={e => (e.target.style.boxShadow = '')}
          />
        </div>

        <button
          type="submit"
          disabled={loading || !email || !password}
          className="w-full py-3 text-white rounded-lg font-medium transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: ACCENT }}
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </button>

        <div className="mt-4 text-center">
          <a href="/production/forgot-password" className="text-sm" style={{ color: ACCENT }}>
            Forgot your password?
          </a>
        </div>
      </form>
    </div>
  );
};
